{
  "loading": "Loading...",
  "close": "Close",
  "goBack": "Go back",
  "next": "Next",
  "change": "Change",
  "submit": "Submit",
  "submitting": "Submitting…",
  "finish": "Finish",
  "quantity": "Qty: {quantity}"
}
